import React from 'react';
import { Text } from '@mlc/web-ui-toolkit';
import ActionLink from '../Common/ActionLink';

interface Props {
	enableEdit: boolean;
	forwardedRef?: any;
	onModeChange?: () => void;
}

const ViewPasswordMask = (props: Props) => {
	return (
		<React.Fragment>
			<Text>* * * * * * * *</Text>
			<ActionLink
				isActive={props.enableEdit}
				handler={() => {
					props.onModeChange && props.onModeChange();
				}}
				id="editPassword"
				label="Edit password"
				forwardedRef={props.forwardedRef}
			/>
		</React.Fragment>
	);
};

export default ViewPasswordMask;
